// LoginCallback.js — completes the OAuth redirect, then sends the user on.
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { safeReturnUrl } from '../../lib/url';

const LoginCallback = () => {
  const { session, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!loading) {
      if (session) {
        const params = new URLSearchParams(location.search);

        // Never redirect to a query-provided foreign origin (open redirect).
        const returnUrl = safeReturnUrl(
          params.get('returnUrl'),
          window.location.origin,
          '/'
        );

        // window.location so an absolute same-origin returnUrl works.
        window.location.replace(returnUrl);
      } else {
        navigate('/login', { replace: true });
      }
    }
  }, [session, loading, navigate, location]);

  if (loading) return <p className="status-line">Processing login...</p>;

  return <p className="status-line">Completing login...</p>;
};

export default LoginCallback;
